import React, { useEffect, useState } from 'react'
import "./Login.css"
import ForgetPass from './ForgetPass'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { useAuth } from './connectApi/auth'
import { useNavigate } from "react-router-dom";
import Loader from '../../components/Loader/Loder'


function Login() {

    const navigate = useNavigate();
    const { checkAuth, getUserLogin } = useAuth((state) => state.actions)
    const isAuth = useAuth((state) => state.isAuth)
    const loader = useAuth((state) => state.loader)


    const [isShowForgetModal, setIsShowForgetModal] = useState(false)
    const showForgetModalHandler = () => {
        setIsShowForgetModal(!isShowForgetModal)
    }
    useEffect(() => {
        localStorage.removeItem("pelakToken")
    }, [])

    return (
        <>
            {/* {
                loader ? (
                    <Loader />
                ) : ( */}
            <div className="area"  >
                <div className='login-modal-content px-[300px] sm:px-2 xl:px-[100px]  text-center flex flex-col gap-6 '>
                    <div className='px-24 sm:p-4 py-6 border border-white border-2 rounded-xl bg-[#41625cbb]'>
                        <img src="/icons/pelakLogo.svg" alt="لوگو پلاک" />
                        <Formik
                            initialValues={{
                                userName: "", pass: ""
                            }}
                            validate={values => {
                                const errors = {};
                                if (values.userName.length < 3) {
                                    errors.userName = ' نام کاربری معتبر نمیباشد';
                                } else if (values.pass.length < 3) {
                                    errors.pass = 'رمز عبور معتبر نمیباشد';
                                }
                                return errors;
                            }}
                            onSubmit={async (values, event, errors) => {
                              
                                await checkAuth(values.userName, values.pass)

                                if (localStorage.getItem("pelakToken")) {
                                    navigate("/TeammateProfileDetails");
                                }
                                getUserLogin()
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                            }) => (
                                <Form onSubmit={handleSubmit} className='text-white flex flex-col gap-4'>
                                    <div className='flex flex-col gap-1 items-start'>
                                        <label htmlFor="userName">نام کاربری</label>
                                        <Field type="text" name="userName" id="userName" className='w-full border-2 border-gray-100 rounded px-2 py-1 outline-none bg-[#3048446b]' />
                                        <ErrorMessage name="userName">{msg => <div className='text-[11px] text-gray-100 pr-2'>{msg}</div>}</ErrorMessage>
                                    </div>
                                    <div className='flex flex-col gap-1 items-start'>
                                        <label htmlFor="pass">رمز عبور</label>
                                        <Field type="password" name="pass" id="userName" className='w-full border-2 border-gray-100 rounded px-2 py-1 outline-none bg-[#3048446b]' />
                                        <ErrorMessage name="pass">{msg => <div className='text-[11px] text-gray-100  pr-2'>{msg}</div>}</ErrorMessage>
                                        <p onClick={() => showForgetModalHandler()} className='cursor-pointer text-[10px] text-end w-full mt-1'>فراموشی رمز عبور؟</p>
                                    </div>
                                    {/* <div className='p-2 border-2 border-white rounded bg-[#3048446b]'>
                                        ربات نیستم
                                    </div> */}
                                    {
                                        isAuth && isAuth.status == 401 ? (
                                            "ورود ناموفق. لطفا نام کاربری و رمزعبور معتبر وارد کنید"
                                        ) : ""
                                    }
                                    <div className='flex items-center justify-center'>
                                        <button onClick={handleSubmit} type='submit'
                                            className={`bg-white text-gray-950 py-1 w-[60%] rounded font-bold ${loader ? "pointer-events-none opacity-60" : "pointer-events-auto opacity-100"} `}>
                                            {
                                                isAuth && isAuth.status == 401 ? (
                                                    "تلاش مجدد"
                                                ) : "ورود"
                                            }
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                    </div>
                </div>
                <ul className="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            {/* )
            } */}

            {
                isShowForgetModal ? (<ForgetPass showForgetModalHandler={showForgetModalHandler} isShowForgetModal={isShowForgetModal} />) : ""
            }
        </>
    )
}

export default Login